import React from "react";
import PropTypes from "prop-types";
import { injectIntl, intlShape } from "react-intl";
import messages from "components/messagesDescription";
import { Button } from "cxa-components";
import ClaimsInfoIcon from "assets/images/claims-info.svg";

const ClaimsCard = ({ claimsInfo, intl }) =>
  !!claimsInfo && (
    <article key={"ClaimsCard"} className="card">
      <header>
        <h2>{intl.formatMessage(messages.claimsDescription)}</h2>
      </header>
      <section className="apl-dashboard__claims">
        <ClaimsInfoIcon />
      </section>
      <footer>
        <Button primary to="/claims/submit">
          {intl.formatMessage(messages.claims.submitClaimDescription)}
        </Button>
        <Button to="/claims/pending" secondary>
          {intl.formatMessage(messages.claims.statusDescription)}
        </Button>
      </footer>
    </article>
  );

ClaimsCard.propTypes = {
  intl: intlShape.isRequired,
  claimsInfo: PropTypes.arrayOf(PropTypes.object),
};

export default injectIntl(ClaimsCard);



// WEBPACK FOOTER //
// ./components/dashboard/widgets/ClaimsCard.js